import $ from 'jquery';
import Backbone from 'backbone';
import Radio from 'backbone.radio';
    var globalCh = Radio.channel('global');

  export default function(){
    var editor_settings_slug = "editor_settings_collection",
    editor_settings = new Backbone.Collection();

    globalCh.reply('editor_settings', function() { return editor_settings; });

    // Function to save the collection
    function persist_editor_settings() {

      var recent_revisions = globalCh.request('recent_revisions');

      // Look at the recently viewed revisions. If we have more than 200 settings
      // in this collection, and we can't find a setting ID within the recent
      // revisions collection, delete that setting from this collection
      // before we save it to localStorage. This should help prevent us from
      // running into localStorage space limitations.
      if (recent_revisions 
        && editor_settings.length > recent_revisions.MAX_LENGTH) {
        editor_settings.each(function(item){
          if (!recent_revisions.contains(item.id)) {
            editor_settings.remove(item);
          }
        });
      }
      localStorage.setItem(editor_settings_slug, 
                            JSON.stringify(editor_settings.toJSON()));
    
    }
    function retrieve_editor_settings() {
      var settings = localStorage.getItem(editor_settings_slug);
      if (settings) { editor_settings.set(JSON.parse(settings)); }
    }
    $(window).on('unload', persist_editor_settings);
    this.on('start', retrieve_editor_settings);

  }

